import { render } from "./SocialMediaAndTermCondition.vue?vue&type=template&id=0a5249f2"
import script from "./SocialMediaAndTermCondition.vue?vue&type=script&lang=js"
export * from "./SocialMediaAndTermCondition.vue?vue&type=script&lang=js"

import "./SocialMediaAndTermCondition.vue?vue&type=style&index=0&id=0a5249f2&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__